import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { rpcCGI } from '@tencent/vft-common/request';
var actId = window.setting.魔方.活动ID;

var myPropertyService = /*#__PURE__*/function () {
  function myPropertyService() {
    _classCallCheck(this, myPropertyService);
  }

  _createClass(myPropertyService, null, [{
    key: "ReadMyPropertyListCgi",
    value:
    /**
     *  查询用户在某活动下获取的奖品列表
     *  @param {String} act_id 活动id
     */
    function ReadMyPropertyListCgi() {
      return rpcCGI('trpc.magic.property_read.PropertyRead/ReadMyPropertyListCgi', {
        act_id: actId
      });
    }
  }]);

  return myPropertyService;
}();

export default myPropertyService;